/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { string, func } from 'prop-types';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './search-field.scss';

import p from 'polyglot/polyglot';

/**
 * This is the SearchField component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Pelle Lundgren <pelle.lundgren@vntrs.com>
 *
 */
const SearchField = ({ value, onChange }) => (
  <div className={styles.wrapper}>
    <input
      className={styles.input}
      type="text"
      value={value}
      onChange={onChange}
      placeholder={p.t('talents.form.submit')}
    />
    <BlackTieIcon className={styles.icon} icon="search" weight="btr" />
  </div>
);

SearchField.propTypes = {
  onChange: func,
  value: string,
};

SearchField.defaultProps = {
  value: '',
  onChange: () => {},
};

export default React.memo(SearchField);
